import { Square, SquareCheck, SquareDashed } from "lucide-react";

import { cn } from "@/lib/utils";

export function BooleanCheckboxIcon({
  value,
  unsetIcon,
  className,
}: {
  value: boolean | undefined;
  unsetIcon?: boolean;
  className?: string;
}) {
  if (value === true) {
    return (
      <SquareCheck className={cn("size-4 opacity-60", className)} aria-hidden />
    );
  }
  if (value === false) {
    return <Square className={cn("size-4", className)} aria-hidden />;
  }
  if (unsetIcon) {
    return (
      <SquareDashed
        className={cn("text-muted-foreground size-4", className)}
        aria-hidden
      />
    );
  }
  return null;
}
